export const site = {
  name: "甜心剧情站",
  tagline: "守护甜心分集剧情 / 剧情解析 / 结局详解",
  description:
    "专注守护甜心动漫的剧情专题站，从第一集到最终话按顺序梳理全部分集剧情，并提供角色解析、设定解读与结局详解。",
  email: "hello@tianxin-jueqing.com",
  slogan: "看动画不用再到处翻，点开就能对照剧情进度。",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "分集剧情", path: "/episodes" },
  { label: "剧情解析", path: "/analysis" },
  { label: "结局详解", path: "/ending" },
  { label: "关于本站", path: "/about" },
];

export const heroCover =
  "https://readdy.ai/api/search-image?query=pastel%20dreamy%20magical%20girl%20anime%20sky%20with%20soft%20pink%20and%20cream%20clouds%2C%20floating%20sparkling%20guardian%20eggs%20and%20little%20stars%2C%20gentle%20light%20rays%2C%20whimsical%20storybook%20illustration%2C%20soft%20glow%2C%20ethereal%20warm%20and%20heartwarming%20atmosphere%2C%20clean%20airy%20composition&width=1800&height=980&seq=hero-dream-cloud&orientation=landscape";

export const endingCover =
  "https://readdy.ai/api/search-image?query=pastel%20magical%20girl%20anime%20style%20wide%20illustration%20of%20a%20warm%20golden%20sunset%20horizon%20with%20silhouettes%20and%20floating%20glowing%20guardian%20eggs%2C%20soft%20pink%20and%20amber%20sky%2C%20dreamy%20storybook%20atmosphere%2C%20hopeful%20and%20heartwarming%2C%20clean%20cinematic%20composition&width=1600&height=720&seq=ending-hero-band&orientation=landscape";

export const aboutCover =
  "https://readdy.ai/api/search-image?query=pastel%20dreamy%20magical%20girl%20anime%20style%20illustration%20of%20open%20books%20and%20glowing%20guardian%20eggs%20floating%20above%20a%20warm%20desk%2C%20soft%20pink%20and%20cream%20tones%2C%20sparkles%20and%20warm%20light%2C%20storybook%20atmosphere%2C%20clean%20composition&width=1600&height=760&seq=about-team-band&orientation=landscape";